import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index.vue'
import Nosotros from '@/views/Nosotros.vue'
import Contacto from '@/views/Contacto.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      {
          path: '/',
          name: 'Index',
          component: Index
      },
      {
          path: '/Nosotros',
          name: 'Nosotros',
          component: Nosotros
      },
      {
          path: '/Contacto',
          name: 'Contacto',
          component: Contacto
      },
  ]
})
